"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Botao = void 0;
var react_1 = __importStar(require("react"));
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Cores_1 = require("../Cores/Cores");
var estiloBotao = require("./Botao.module.scss");
var Botao = function (_a) {
    var id = _a.id, _b = _a.estilo, estilo = _b === void 0 ? "primaryDark" : _b, _c = _a.tamanho, tamanho = _c === void 0 ? "large" : _c, _d = _a.tipo, tipo = _d === void 0 ? "tipoDefault" : _d, _e = _a.desabilitado, desabilitado = _e === void 0 ? false : _e, _f = _a.exibirBotaoArrendondado, exibirBotaoArrendondado = _f === void 0 ? false : _f, _g = _a.tipoComportamento, tipoComportamento = _g === void 0 ? "button" : _g, children = _a.children, cor = _a.cor, corTexto = _a.corTexto, style = _a.style, title = _a.title, onClick = _a.onClick, onKeyDown = _a.onKeyDown;
    var estiloTamanhoBotao = estiloBotao[tamanho] || "";
    var estiloTipoBotao = estiloBotao[tipo] || "";
    var buttonEstilo = desabilitado ? estiloBotao.disabled : estiloBotao[estilo] || "";
    var _h = react_1.default.useState(Cores_1.Cores.CoresIdentidadeMU.brancoMu), corFonte = _h[0], setCorFonte = _h[1];
    var handleKeyDown = (0, react_1.useCallback)(function (e) {
        if (onKeyDown && !desabilitado) {
            onKeyDown(e);
        }
    }, [onKeyDown, desabilitado]);
    (0, react_1.useEffect)(function () {
        if (estilo === 'outlined' || estilo === "ghost") {
            setCorFonte(Cores_1.Cores.CoresIdentidadeMU.cinzaMu);
        }
        else if (estilo === 'text') {
            setCorFonte(Cores_1.Cores.CoresIdentidadeMU.azulMu);
        }
    }, [estilo]);
    (0, react_1.useEffect)(function () {
        if (!desabilitado && onKeyDown)
            window.addEventListener("keydown", handleKeyDown);
        return function () {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [desabilitado, onKeyDown, handleKeyDown]);
    return (react_1.default.createElement("button", { id: id, type: tipoComportamento, onClick: function () { return onClick && !desabilitado && onClick(); }, title: title, className: "\n                ".concat(estiloTipoBotao, " ").concat(estiloBotao.MUbutton, " ").concat(estiloTamanhoBotao, " \n                ").concat(buttonEstilo, " ").concat(exibirBotaoArrendondado && estiloBotao.rounded_variant, "\n                ").concat(!onClick && estiloBotao.naoClicavel), style: __assign({ backgroundColor: cor, color: corTexto }, style) },
        react_1.default.createElement("div", { className: estiloBotao.children }, children ? children : react_1.default.createElement(Corpo_1.Corpo, { tipo: "button1", cor: corFonte, negrito: 700 }, "Bot\u00E3o"))));
};
exports.Botao = Botao;
